import {useEffect, useRef, useState} from "react";

/**
 * header에 적용되는 layout.js를 리엑트 커스텀 훅으로 변경
 */
export const useHeaderLayout = () => {
    const [isPCScreen, setIsPCScreen] = useState(window.innerWidth >= 1241);
    const [isHeight, setIsHeight]     = useState(false);

    // useRef는 querySelector와 같은 역할 수행 가능 즉 원하는 dom에 접근 가능
    const searchBoxRef  = useRef(null);
    const searchAreaRef = useRef(null);
    const toggleBtnRef  = useRef(null);

    // 윈도우(디바이스) 너비마다 searchbox의 높이를 지정
    const getSearchBoxHeight = () => {
        const width = window.innerWidth;
        if (width <= 580) {
            return '204px';
        } else if (width <= 768) {
            return '218px';
        } else if (width <= 1023) {
            return '238px';
        }
        return '258px';
    }

    // 윈도우(디바이스) 너비마다 searchbox의 padding(안쪽 여백) 지정
    const getSearchBoxPadding = () => {
        const width = window.innerWidth;
        if (width <= 580) {
            return '116px 16px 40px';
        } else if (width <= 768) {
            return '120px 16px 50px';
        } else if (width <= 1023) {
            return '130px 16px 60px';
        }
        return '140px 0 70px';
    }

    // 윈도우(디바이스) 너비마다 search 버튼 기능 
    const handleSearchToggle = () => {
        if (isHeight) return;

        // PC : 검색 영역 옆으로 넓어짐
        // 기능시 toggleBtn에 toggle 클래스가 없어야 함(모바일에서만 적용되기 때문)
        if (isPCScreen) {
            searchBoxRef.current.classList.add('active');
            toggleBtnRef.current.classList.remove('toggle');
            searchAreaRef.current.style.opacity = '1';
            if (searchBoxRef.current.classList.contains("active")) {
                toggleBtnRef.current.style.display = 'none';
            }
        } else {
            // 태블릿 ~ 모바일 : 검색 영역 밑으로 내려옴 
            // 기능시 toggleBtn에 toggle 클래스가 있어야 함 
            setIsHeight(true);
            toggleBtnRef.current.classList.add('toggle');

            // 검색영역이 이미 열려있으면 닫음
            if (searchBoxRef.current.classList.contains("active")) {
                searchBoxRef.current.style.height   = '0';
                searchBoxRef.current.style.padding  = '0';
                searchAreaRef.current.style.opacity = '0';
                toggleBtnRef.current.style.display  = 'none';

                // 검색영역이 자연스럽게 닫히기 위해 setTimeout 사용
                setTimeout(() => {
                    searchBoxRef.current.classList.remove('active');
                    toggleBtnRef.current.style.display = 'block';
                    setIsHeight(false);
                }, 500);
            } else {
                // 검색영역 열고, 윈도우(디바이스) 너비 확인해서 검색영역 높이와 안쪽 여백 지정
                searchBoxRef.current.classList.add('active');
                searchBoxRef.current.style.height   = getSearchBoxHeight();
                searchBoxRef.current.style.padding  = getSearchBoxPadding();
                searchAreaRef.current.style.opacity = '1';
                setTimeout(() => {
                    setIsHeight(false);
                }, 500);
            }
        }
    };

    // 커스텀 훅 내부에서 window resize 이벤트를 감지하고 자동으로 실행되는 구조
    useEffect(() => {
        // 윈도우(디바이스) 너비가 변경될 때 클래스 및 css 초기화
        const handleResize = () => {
            const newIsPCScreen = window.innerWidth >= 1241;

            if (isPCScreen !== newIsPCScreen) {
                setIsPCScreen(newIsPCScreen);

                if (searchBoxRef.current) {
                    searchBoxRef.current.classList.remove('active');
                    searchBoxRef.current.style.height   = '';
                    searchBoxRef.current.style.padding  = '0';
                    searchAreaRef.current.style.opacity = '0';
                    toggleBtnRef.current.classList.remove('toggle');
                    toggleBtnRef.current.style.display = 'block';
                    setIsHeight(false);
                }
            } else if (!isPCScreen && searchBoxRef.current?.classList.contains('active')) {
                searchBoxRef.current.style.height  = getSearchBoxHeight();
                searchBoxRef.current.style.padding = getSearchBoxPadding();
            }
        };

        // 이벤트 중복 방지
        window.addEventListener('resize', handleResize);

        // 클린업 함수: 언마운트 시 함수 정리
        return () => window.removeEventListener('resize', handleResize);

        // isPCScreen이 현재 화면 넓이를 의미 따라서 화면 넓이에 따라 useEffect로 이벤트 발생시킴
    }, [isPCScreen]);

    return {
        searchBoxRef,
        searchAreaRef,
        toggleBtnRef,
        handleSearchToggle
    };
};